import { useState, useEffect } from "react";

const BOGItems = ({ isShow = false, enableQrGenerator }) => {
    const [value, setValue] = useState("");
    const [isLimitReached, setIsLimitReached] = useState(false);  // State to track character limit
    const [showWarning, setShowWarning] = useState(false);  // State to manage the visibility of the warning message
    const maxCharactersAllowed = 1000;

    const handleChange = (e) => {
        let input = e.target.value;

        // Remove any special characters
        input = input.replace(/[^a-zA-Z0-9, ]/g, "");

        // Replace multiple commas with a single one
        input = input.replace(/,+/g, ",");

        // Check if the length exceeds the limit before updating the value
        if (input.length <= maxCharactersAllowed) {
            setValue(input);
            setIsLimitReached(false);  // Reset warning if under limit
        } else if (!isLimitReached) {
            // Show the warning once and prevent further input
            setIsLimitReached(true);
            setShowWarning(true);
        }

        setTimeout(() => {
            enableQrGenerator();
        }, 50);
    };

    // Handle Paste Event
    const handlePaste = (e) => {
        const pastedText = e.clipboardData.getData('text');
        let input = value + pastedText;

        // Remove any special characters and limit the characters to maxCharactersAllowed
        input = input.replace(/[^a-zA-Z0-9, ]/g, "");
        input = input.replace(/,+/g, ",");

        if (input.length > maxCharactersAllowed) {
            input = input.slice(0, maxCharactersAllowed); // Crop it to 1000 characters
            if (!isLimitReached) {
                // Show the warning if it's the first time reaching the limit
                setIsLimitReached(true);
                setShowWarning(true);
            }
        }

        // Update the value with the cropped input
        setValue(input);
        e.preventDefault();  // Prevent default paste action
        setTimeout(() => {
            enableQrGenerator();
        }, 50);
    };

    useEffect(() => {
        setValue("");
        setIsLimitReached(false);  // Reset warning when component is shown
        setShowWarning(false);  // Hide warning when isShow changes
    }, [isShow]);

    useEffect(() => {
        if (isLimitReached && showWarning) {
            // Hide the warning after 3 seconds
            const timer = setTimeout(() => {
                setShowWarning(false);
            }, 3000);

            // Cleanup the timer on component unmount or when the warning state changes
            return () => clearTimeout(timer);
        }
    }, [isLimitReached, showWarning]);

    return (
        isShow ?
            <div className="row row-flex mt-4">
                <div className="col-md-4 col-sm-12">
                    <div className="add-player-div d-flex flex-column border border-light p-2">
                        <h6 className="text-dark"><b>Enter the product details (Separated by Commas)</b></h6>
                        {showWarning && isLimitReached ?
                            <h6 className="text-danger"><span><b>*</b></span><i>Only {maxCharactersAllowed} characters allowed.</i></h6>
                            :
                            <h6 className="text-dark"><span><b>*</b></span><i>No special characters allowed</i></h6>
                        }
                        <textarea
                            value={value}
                            onChange={handleChange}
                            onPaste={handlePaste}  // Handle paste event
                            name="basket-items"
                            id="basket-items"
                            rows={4}
                            style={{ overflow: "auto", resize: "none" }}
                            className="mb-3 form-control"
                        />
                    </div>
                </div>
            </div> : null
    );
};

const BOGDisclaimer = ({ logic }) => {
    const [showDisclaimer, setShowDisclaimer] = useState(false);
    const [disclaimerMessage, setDisclaimerMessage] = useState("");
    useEffect(() => {
        let timer;
        const condition =
            logic.isBasketFinance &&
            logic.loanableAmount > 0 &&
            // logic.loanableAmount >= logic.minLoanAmount &&
            logic.eligibleSegments.length === 0;

        setDisclaimerMessage(logic.loanableAmount < logic.minLoanAmount ? 
                `Minimum loanable amount for this commodity is ${logic.formatter.format(logic.minLoanAmount)}` 
                : `Maximum loanable amount for this commodity is ${logic.formatter.format(logic.maxLoanAmount)}`); 
        if (condition) {
            timer = setTimeout(() => setShowDisclaimer(true), 100); // 1 ms delay
        } else {
            setShowDisclaimer(false); // hide if condition fails
        }

        return () => clearTimeout(timer); // cleanup on unmount or logic change
    }, [logic]);

    return (
        showDisclaimer ? 
        <p className="basket-disclaimer-note">{disclaimerMessage}</p> : null
    );
}

export { BOGItems, BOGDisclaimer };